import {faLock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {useAppStore} from "../GlobalStore/GlobalStore.ts";
import InfoButton from "./MiddlePopup/Settings/SettingsContent/Subcomponents/InfoButton/InfoButton.tsx";
import {isSubscribed} from "../Utils/misc/userInsightUtils.ts";

interface OverlayWrapperProps {
    children: any;
    type?: string;
    toolTipDirection?: 'left' | 'right' | 'top' | 'bottom' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
    customTooltipContent?: string;
}
export const OverlayWrapper: React.FC<OverlayWrapperProps> = ({ children, type = "preview", toolTipDirection = "bottom", customTooltipContent }) => {
    const userObj = useAppStore((state: any) => state.userObj);
    const { subscriptionPlan, remainingBalance, monthlyFreeMessages } = userObj;

    const getCondition = () => {
        const defaultCondition = {
            conditionText: "",
            conditionClause: false,
            tooltipContent: customTooltipContent || ""
        };

        if (type === "paidOnly") return {
            conditionText: "Paid Users Only",
            conditionClause: !isSubscribed(subscriptionPlan, monthlyFreeMessages),
            tooltipContent: customTooltipContent || "This feature is available for paid users only. <a href='https://www.onuro.ai/pricing'>Learn more</a>"
        };
        else if (type === "outOfUsage") return {
            conditionText: "Usage Limit Reached",
            conditionClause: subscriptionPlan === "pro" && remainingBalance <= 0,
            tooltipContent: customTooltipContent || ""
        };
        else if (type === "usageBasedDisabled") return {
            conditionText: "Usage pricing disabled",
            conditionClause: subscriptionPlan === "hybrid" && !userObj.hasUsageBasedEnabled,
            tooltipContent: customTooltipContent || "Enable usage-based pricing in your account settings to use this feature"
        };
        else if (type === "apiKeyModeNoKey") return {
            conditionText: "No API Key Entered",
            conditionClause: true, // This will be controlled by the parent component
            tooltipContent: customTooltipContent || "API key mode is enabled, but no API key has been entered for this provider"
        };
        else return defaultCondition;
    };

    const conditions = getCondition();

    return (
        <div className="relative">
            {children}
            {conditions.conditionClause && (
                <div
                    className="absolute rounded-md inset-0 bg-neutral-900 bg-opacity-90 flex items-center justify-center border border-neutral-600">
                    <div className="text-white font-semibold flex items-center text-sm">
                        <FontAwesomeIcon icon={faLock} className="mr-2"/>
                        {conditions.conditionText}
                        {conditions.tooltipContent && (
                            <div className="ml-2 mt-1">
                                <InfoButton
                                    tooltipId={`overlay-info-${type}`}
                                    tooltipContent={conditions.tooltipContent}
                                    direction={toolTipDirection}
                                />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}